<div class="visitor-campaign-criterion-block">
  <div class="criterion-block-body">
    <div *ngIf="isNested" class="criterion-nested-marker"></div>
    <div class="criterion-block-container" [ngClass]="{'nested-criterion-block-container': isNested}">
      <div *ngFor="let operand of campaignConditions.operands; last as isLast" class="criterion-block">

        <app-visitor-campaign-criterion *ngIf="operand.type === 'criterion'"
                                        [criterion]="operand"
                                        [operator]="campaignConditions.operator">
        </app-visitor-campaign-criterion>

        <app-visitor-campaign-criterion-block *ngIf="operand.type === 'group'"
                                              [campaignConditions]="operand"
                                              [isNested]="true">
        </app-visitor-campaign-criterion-block>

        <div *ngIf="!isLast" class="criterion-operator">{{ campaignConditions.operator }}</div>
      </div>
    </div>
  </div>
</div>
